import React ,{useState,useEffect}from 'react'
import Modal from "react-bootstrap/Modal";
import { useFormik } from 'formik';
import * as Yup from "yup"
import {storeFacebookIntegrationCredentials} from "../../../../services/ApiService"
import { toast } from 'react-toastify';


const validationSchema=Yup.object({
  client_id:Yup.string().required('Client Id is required'),
  client_secret:Yup.string().required('Client Secret is required'),
  account_type:Yup.string().required('Account Type is required'),


})

const FacebookIntegrationDetails = ({show,setShow,setConnecting,handleConnect,account_type}) => {

const [loading,setLoading]=useState(false)
// const [initialValues,setInitialValues]=useState({
//   client_id:"",
//   client_secret:"",
//   account_type:account_type
// })

const initiateFacebookIntegration=async(values)=>{
  try{
    if(values.client_id==="" || values.client_secret===""){
      toast.error("Please enter client id and client secret")
      return
    }
    if(values.account_type===""){
      toast.error("Please select account type")
      return
    }
    let result=await storeFacebookIntegrationCredentials(values)
    
    handleConnect()
    



  }catch(e){
    console.log(e)
  }
}

const formik=useFormik({
  initialValues:{
    client_id:"",
    client_secret:"",
    account_type:account_type
  },
  validationSchema:validationSchema,
  onSubmit:async (values)=>{
   try{
      setLoading(true)
      initiateFacebookIntegration(values)
     

    }catch(e)
    {
      console.log(e)
      toast.error("Failed to store facebook credentials")

    }finally{
      setLoading(false)
     
    }

  }
})

const getFacebookIntegrationCredentials=async()=>{
  try{
    const client_id=process.env.REACT_APP_FACEBOOK_CLIENT_ID
    const client_secret=process.env.REACT_APP_FACEBOOK_CLIENT_SECRET
    // setInitialValues({
    //   client_id:client_id,
    //   client_secret:client_secret,
    //   account_type:account_type
    // })
    // formik.setValues({
    //   client_id:client_id,
    //   client_secret:client_secret,
    //   account_type:account_type
    // })

    initiateFacebookIntegration({client_id:client_id,client_secret:client_secret,account_type:account_type})
    
  }catch(e){
    console.log(e)
  }
}


// useEffect(()=>{
//   // getFacebookIntegrationCredentials() 
// },[])



  return (
    <div>
          <Modal
        show={show}
        onHide={() => {
          setShow(false);
          setConnecting(false)
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
       
          <div className="d-flex flex-column gap-1">
            <span className="fs-4 fw-bold">
             Facebook Integration
            </span>
            <small className="fs-8">
               Please enter facebook credentials to integrate facebook ads
            </small>
          </div>
        </Modal.Header>
        <Modal.Body className="overflow-auto" style={{ minHeight: "30vh" }}>
          <form action="" onSubmit={formik?.handleSubmit}>
            <div className='py-2 '>
              <label htmlFor="" className='mb-1'>Client Id</label>
              <input type="text" 
              id="client_id" 
              name="client_id" 
              className='form-control '
              onChange={formik?.handleChange}
              value={formik?.values?.client_id}
               />
              {formik?.touched?.client_id && formik?.errors?.client_id && <p className='text-center text-danger mb-0'>{formik?.errors?.client_id}</p>}
            </div>
            <div className='py-2 '>
              <label htmlFor="" className='mb-1'>Client Secret</label>
              <input type="text" 
              id="client_secret" 
              name="client_secret"
              onChange={formik?.handleChange}
              value={formik?.values?.client_secret}
               className='form-control ' />
              {formik?.touched?.client_secret && formik?.errors?.client_secret && <p className='text-center text-danger mb-0'>{formik?.errors?.client_secret}</p>}
            </div>

            <div className='pt-4 d-flex justify-content-between'>
                       <a  target='_blank'  className='text-decoration-none text-primary'
                         style={{ cursor: "pointer" }}
              onClick={()=>getFacebookIntegrationCredentials()}
              > {loading?"Please Wait...":"Connect To Facebook"} </a>

              <button type="submit" className='btn btn-primary'
              onClick={handleConnect}
              > {loading?"Please Wait...":"Submit"} </button>
     
            </div>


          </form>


        </Modal.Body>

      </Modal>
    </div>
  )
}

export default FacebookIntegrationDetails